module.exports = __webpack_public_path__ + "static/media/pic6.a20b7ba0.jpg";